import React from 'react'
// ##
import BrandsTable from '../../modules/Brand/components/BrandsTable'

export default function BrandPage() {
  return <BrandsTable />
}
